import * as FormulaFunctions from './utilities/FormulaFunctions';
import * as TypeEvaluation from './TypeEvaluation';
import * as StyleFunctions from './utilities/StyleFunctions';


export function getCardItems(sortedCardItemKeys, itemInfoPath, cardItems, currentList, internalVariables, width, height, upwardInfo, inputValues, ownVariables, urlParamsForExecution, urlHeader, chains, interactionFn, doACardPiece, gotHeaderForFirst){
  var cardPieces = [];
  sortedCardItemKeys.forEach((aCardItemKey, index)=>{

    var firstRowHeader = false;
    if (+index === 0 && gotHeaderForFirst){
      firstRowHeader = true;
    }
    var thisCardPath = itemInfoPath.concat(['i', aCardItemKey]);
    var thisCard = cardItems[aCardItemKey];

    var rForm = StyleFunctions.getStyleValueR('rFormula', thisCard.s, thisCardPath.concat(['s']), currentList, internalVariables, width, height, upwardInfo, inputValues, ownVariables, urlParamsForExecution, urlHeader, chains);
    if (interactionFn){
      if (!rForm){
        doACardPiece(thisCard, thisCardPath, [], cardPieces, firstRowHeader, index, currentList);
      }else{
        try{
          rForm.forEach((aRVal, index2)=>{
            doACardPiece(thisCard, thisCardPath, [{t:'gV', p:thisCardPath, v:aRVal}], cardPieces, firstRowHeader, index2, currentList);
          })
        }catch(err){

        }
      }
    }else{
      var toAdd = figureOutToAdd(rForm, thisCard, thisCardPath, currentList, upwardInfo);
      doACardPiece(thisCard, thisCardPath, toAdd, cardPieces, firstRowHeader, index, currentList);
    }
  })
  return cardPieces;  
}
function figureOutToAdd(rForm, thisCard, thisCardPath, currentList, upwardInfo){
  if (!rForm){
    return [];
  }else if (rForm.length > 0){
    return [{t:'gV', p:thisCardPath, v:rForm[0]}];
  }else{
    var objectType = TypeEvaluation.evalType(thisCard.s.rFormula.o, thisCardPath, currentList, upwardInfo);
    var cc = objectType.c;
    var defP = FormulaFunctions.getDefaultValues(cc);
    return [{t:'gV', p:thisCardPath, v:defP}];
  }

}
